import { Grid, Typography } from '@mui/material';

import { PlanFeaturesFields } from '../plan-features-fields';
import { PlanCatalogPricingNotice } from '../plan-catalog-pricing-notice';

import { OutlinedInputController } from 'controllers/outlined-input-controller';
import { SelectController } from 'controllers/select-controller';
import { NumericFormatInputController } from 'controllers/numeric-format-input-controller';

import { recurringFields } from 'pages/plans/utils';
import { amoutInputConfig } from './utils';

import { planModalBodyStyles } from './styles';

interface IProps {
  isEditMode?: boolean;
}

export const PlanModalBody = ({ isEditMode = false }: IProps) => {
  return (
    <Grid sx={planModalBodyStyles.container}>
      <OutlinedInputController
        withError
        name="name"
        label="Plan Name"
        defaultValue=""
        fullWidth
        placeholder="Plan Name"
      />
      <OutlinedInputController
        withError={!isEditMode}
        disabled={isEditMode}
        name="externalProductId"
        label="PayKickstart Product ID"
        fullWidth
        placeholder="PayKickstart Product ID"
      />
      <Grid sx={planModalBodyStyles.amountContainer}>
        <NumericFormatInputController
          withError
          allowNegative={false}
          fullWidth
          type="tel"
          label="# of Projects"
          name="ofProjects"
          placeholder="Leave empty for unlimited"
        />
        <NumericFormatInputController
          withError
          allowNegative={false}
          fullWidth
          type="tel"
          label="# of Users"
          name="ofUsers"
          placeholder="Leave empty for unlimited"
        />
      </Grid>
      <PlanCatalogPricingNotice />
      <Grid sx={planModalBodyStyles.amountContainer}>
        <NumericFormatInputController {...amoutInputConfig} label="Display Amount" name="amount" />
        <SelectController
          withError
          label="Billing Period"
          name="recurring"
          placeholder="Billing Period"
          options={recurringFields}
          defaultValue="MONTHLY"
        />
      </Grid>
      <NumericFormatInputController
        withError
        allowNegative={false}
        decimalScale={0}
        fullWidth
        type="tel"
        label="Trial Days"
        name="trialDays"
        placeholder="0"
      />
      <PlanFeaturesFields />
      <Typography sx={planModalBodyStyles.helperText}>
        Empty project or user limits mean unlimited.
      </Typography>
    </Grid>
  );
};
